import { ReactNode, useEffect } from 'react';
import { useEventFlattedViewSelectedLegend } from 'src/components/Events/EventListing/useEventFlattedViewSelectedLegend';
import { useContent } from 'src/contexts/ContentContext';
import { useMultiSelectionContext } from 'src/contexts/MultiSelectionContext';
import { ContentId } from 'src/utils/constants/contentId';

interface SetSalesFlattenedViewSelectionCountLabelProps {
  children: ReactNode;
}

export const SetSalesFlattenedViewSelectionCountLabel = ({
  children,
}: SetSalesFlattenedViewSelectionCountLabelProps) => {
  const listingText = useContent(ContentId.Sale);
  const listingsText = useContent(ContentId.Sales);
  const { setSelectedCountLabel, setUsingCustomSelectedCountLabel } =
    useMultiSelectionContext();

  useEffect(() => {
    setUsingCustomSelectedCountLabel(true);
  }, [setUsingCustomSelectedCountLabel]);

  const selectedLegend = useEventFlattedViewSelectedLegend({
    singleElementLabel: listingText,
    multipleElementsLabel: listingsText,
  });

  useEffect(() => {
    setSelectedCountLabel(selectedLegend);
  }, [selectedLegend, setSelectedCountLabel]);

  return <>{children}</>;
};
